<template>
  <button
    v-tooltip.top="`Bullet List`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="editor.chain().focus().toggleBulletList().run()"
  >
    <Icon
      name="material-symbols:format-list-bulleted"
      class="h-[20px] w-[20px]"
    />
  </button>

  <button
    v-tooltip.top="`Order List`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="editor.chain().focus().toggleOrderedList().run()"
  >
    <Icon
      name="material-symbols:format-list-numbered"
      class="h-[20px] w-[20px]"
    />
  </button>
</template>

<script setup lang="ts">
const editor = defineModel('editor')
</script>

<style>
.tiptap ul {
    list-style: disc;
    padding-left: 1.5rem;
    margin: 1rem 0;
}

.tiptap ol {
    list-style: decimal;
    padding-left: 1.5rem;
  margin: 1rem 0;

}
</style>
